import { HgSupportedLanguage } from '@smg-real-estate/domus';
import type { GeoLocation } from '@smg-real-estate/geo-libs';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  buildDirectoryBreadcrumbs,
  type DirectoryBreadcrumbLink,
} from '@/helpers/SEO/directoryBreadcrumb';
import { useGeoStore } from '@/stores/geo';
import type { DirectoryType } from '@/types/directoryType';

export function useDirectoryBreadcrumbs(
  directoryType: MaybeRefOrGetter<DirectoryType>,
  searchedLocations: MaybeRefOrGetter<GeoLocation[]>,
) {
  const { t, locale } = useI18n();
  const geoStore = useGeoStore();

  return computed<DirectoryBreadcrumbLink[]>(() => {
    const type = toValue(directoryType);

    return buildDirectoryBreadcrumbs({
      directoryType: type,
      searchedLocations: toValue(searchedLocations),
      language: locale.value as HgSupportedLanguage,
      homepageLabel: t('breadcrumbs.homepage'),
      directoryHubLabel: t(`breadcrumbs.${type}Directory`),
      getLocationsById: geoStore.getGeoLocationsById,
      getLocationName: geoStore.getGeoLocationName,
    });
  });
}
